/**
 * Dependencies.
 */
// import '@mdi/font/css/materialdesignicons.min.css';

import {
  mdiAccessPoint,
  mdiAccount,
  mdiAccountMultiplePlus,
  mdiAccountOff,
  mdiAccountSupervisor,
  mdiAccountTie,
  mdiAccountVoice,
  mdiArrowDown,
  mdiArrowLeft,
  mdiArrowTopRight,
  mdiArrowUp,
  mdiAt,
  mdiAttachment,
  mdiBell,
  mdiBookRemoveMultipleOutline,
  mdiBullhorn,
  mdiBullhornOutline,
  mdiBullseyeArrow,
  mdiCalendar,
  mdiCancel,
  mdiCashMultiple,
  mdiChartAreasplineVariant,
  mdiCheck,
  mdiCheckAll,
  mdiCheckboxMultipleBlank,
  mdiCheckCircle,
  mdiCheckCircleOutline,
  mdiCheckDecagram,
  mdiChevronDown,
  mdiChevronDownCircleOutline,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiCircle,
  mdiCircleOutline,
  mdiClipboardTextOutline,
  mdiClose,
  mdiCloseCircleOutline,
  mdiCloudDownload,
  mdiCloudSearchOutline,
  mdiCloudUpload,
  mdiCloudUploadOutline,
  mdiCog,
  mdiCommentQuestion,
  mdiCommentTextMultipleOutline,
  mdiContentCopy,
  mdiCurrencyEur,
  mdiCursorPointer,
  mdiDebugStepOver,
  mdiDelete,
  mdiDotsHorizontal,
  mdiDownload,
  mdiDumbbell,
  mdiEarth,
  mdiEmail,
  mdiEmoticonHappyOutline,
  mdiEmoticonOutline,
  mdiExport,
  mdiEye,
  mdiEyeOff,
  mdiFacebook,
  mdiFile,
  mdiFileOutline,
  mdiFilePlus,
  mdiFilter,
  mdiFilterOutline,
  mdiFinance,
  mdiFoodForkDrink,
  mdiForum,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiGiftOpen,
  mdiHanger,
  mdiHeadset,
  mdiHeart,
  mdiHeartOff,
  mdiHeartOutline,
  mdiHelp,
  mdiHome,
  mdiHomeLightbulbOutline,
  mdiHours24,
  mdiImage,
  mdiImageAlbum,
  mdiImageMultiple,
  mdiImageOutline,
  mdiInformation,
  mdiInstagram,
  mdiLink,
  mdiLinkVariant,
  mdiLipstick,
  mdiLock,
  mdiLogout,
  mdiMagnify,
  mdiMagnifyMinusOutline,
  mdiMagnifyPlusOutline,
  mdiMapMarkerOutline,
  mdiMenuLeft,
  mdiMenuRight,
  mdiMessage,
  mdiMessageReply,
  mdiMessageText,
  mdiMicrophone,
  mdiMicrophoneOutline,
  mdiMoviePlayOutline,
  mdiOpenInNew,
  mdiPageNextOutline,
  mdiPause,
  mdiPencil,
  mdiPill,
  mdiPlay,
  mdiPlayBoxOutline,
  mdiPlaylistCheck,
  mdiPlus,
  mdiPoll,
  mdiPound,
  mdiReceipt,
  mdiReply,
  mdiRotateLeft,
  mdiRotateRight,
  mdiSend,
  mdiShoeSneaker,
  mdiShopping,
  mdiShoppingSearch,
  mdiSkipNext,
  mdiSlotMachine,
  mdiSunglasses,
  mdiTagPlusOutline,
  mdiTagRemoveOutline,
  mdiTagTextOutline,
  mdiTelegram,
  mdiTextBoxRemoveOutline,
  mdiThumbDown,
  mdiThumbUp,
  mdiTimerSandEmpty,
  mdiTranslate,
  mdiTrashCanOutline,
  mdiTwitch,
  mdiTwitter,
  mdiUndo,
  mdiVideo,
  mdiVideoOutline,
  mdiViewGrid,
  mdiViewList,
  mdiVolumeHigh,
  mdiVolumeOff,
  mdiWatchVariant,
  mdiYoutube
} from '@mdi/js';
import { registerIcons } from '@prz-dp/ui';

import {
  partnerCampaign,
  prozisAlphaP,
  prozisCoins
} from '@/modules/social-network/assets/social-network-icons';

/**
 * Register icons.
 */
registerIcons({
  mdiAccessPoint,
  mdiAccount,
  mdiAccountMultiplePlus,
  mdiAccountOff,
  mdiAccountSupervisor,
  mdiAccountTie,
  mdiAccountVoice,
  mdiArrowDown,
  mdiArrowLeft,
  mdiArrowTopRight,
  mdiArrowUp,
  mdiAt,
  mdiAttachment,
  mdiBell,
  mdiBookRemoveMultipleOutline,
  mdiBullhorn,
  mdiBullhornOutline,
  mdiBullseyeArrow,
  mdiCalendar,
  mdiCancel,
  mdiCashMultiple,
  mdiChartAreasplineVariant,
  mdiCheck,
  mdiCheckAll,
  mdiCheckCircle,
  mdiCheckCircleOutline,
  mdiCheckDecagram,
  mdiCheckboxMultipleBlank,
  mdiChevronDown,
  mdiChevronDownCircleOutline,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiCircle,
  mdiCircleOutline,
  mdiClipboardTextOutline,
  mdiClose,
  mdiCloseCircleOutline,
  mdiCloudDownload,
  mdiCloudSearchOutline,
  mdiCloudUpload,
  mdiCloudUploadOutline,
  mdiCog,
  mdiCommentQuestion,
  mdiCommentTextMultipleOutline,
  mdiContentCopy,
  mdiCurrencyEur,
  mdiCursorPointer,
  mdiDebugStepOver,
  mdiDelete,
  mdiDotsHorizontal,
  mdiDownload,
  mdiDumbbell,
  mdiEarth,
  mdiEmail,
  mdiEmoticonHappyOutline,
  mdiEmoticonOutline,
  mdiExport,
  mdiEye,
  mdiEyeOff,
  mdiFacebook,
  mdiFile,
  mdiFileOutline,
  mdiFilePlus,
  mdiFilter,
  mdiFilterOutline,
  mdiFinance,
  mdiFoodForkDrink,
  mdiForum,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiGiftOpen,
  mdiHanger,
  mdiHeadset,
  mdiHeart,
  mdiHeartOff,
  mdiHeartOutline,
  mdiHelp,
  mdiHome,
  mdiHomeLightbulbOutline,
  mdiHours24,
  mdiImage,
  mdiImageAlbum,
  mdiImageMultiple,
  mdiImageOutline,
  mdiInformation,
  mdiInstagram,
  mdiLink,
  mdiLinkVariant,
  mdiLipstick,
  mdiLock,
  mdiLogout,
  mdiMagnify,
  mdiMagnifyMinusOutline,
  mdiMagnifyPlusOutline,
  mdiMapMarkerOutline,
  mdiMenuLeft,
  mdiMenuRight,
  mdiMessage,
  mdiMessageReply,
  mdiMessageText,
  mdiMicrophone,
  mdiMicrophoneOutline,
  mdiMoviePlayOutline,
  mdiOpenInNew,
  mdiPageNextOutline,
  mdiPause,
  mdiPencil,
  mdiPill,
  mdiPlay,
  mdiPlayBoxOutline,
  mdiPlaylistCheck,
  mdiPlus,
  mdiPoll,
  mdiPound,
  mdiReceipt,
  mdiReply,
  mdiRotateLeft,
  mdiRotateRight,
  mdiSend,
  mdiShoeSneaker,
  mdiShopping,
  mdiShoppingSearch,
  mdiSkipNext,
  mdiSlotMachine,
  mdiSunglasses,
  mdiTagPlusOutline,
  mdiTagRemoveOutline,
  mdiTagTextOutline,
  mdiTelegram,
  mdiTextBoxRemoveOutline,
  mdiThumbDown,
  mdiThumbUp,
  mdiTimerSandEmpty,
  mdiTranslate,
  mdiTrashCanOutline,
  mdiTwitch,
  mdiTwitter,
  mdiUndo,
  mdiVideo,
  mdiVideoOutline,
  mdiViewGrid,
  mdiViewList,
  mdiVolumeHigh,
  mdiVolumeOff,
  mdiWatchVariant,
  mdiYoutube,
  partnerCampaign,
  prozisAlphaP,
  prozisCoins
});
